import { useEffect, useState } from 'react';
import eventQueue from '../events/queue';
import { useAppDispatch, useAppSelector } from '../state';
import { selectCurrentSource, updateEventSource, } from '../state/slices/slice-segment';
/**
 * This is a hook that updates the event source on surface component
 * initialization. It also returns `fireEvent` which is an event-firing
 * function that is bound to the correct surfaces.
 *
 * @param newSurface - The surface/page the user is on
 * @returns { fireImpressionEvent: (optionalEventParams?: OptionalEventParams) => void; }
 */
var usePageTracking = function (newSurface) {
    var currentSource = useAppSelector(selectCurrentSource);
    var dispatch = useAppDispatch();
    var _a = useState(null), impressionPayload = _a[0], _setImpressionPayload = _a[1];
    // Because we have a useEffect hook with a dependency on `impressionPayload`,
    // updating this payload will trigger the effect to run, effectively firing
    // the impression event.
    var fireImpressionEvent = _setImpressionPayload;
    useEffect(function () {
        /**
         * Check for impression payload. Initially impression payload will be
         * null, and we do not want to fire an impression event before we set
         * the appropriate payload (check for both null and undefined to be safe).
         */
        if (impressionPayload == null)
            return;
        if (newSurface !== currentSource)
            dispatch(updateEventSource(newSurface));
        eventQueue.emit('impression', { params: impressionPayload || {} });
    }, [impressionPayload]); // eslint-disable-line react-hooks/exhaustive-deps
    return { fireImpressionEvent: fireImpressionEvent };
};
export default usePageTracking;
